import { dsStudioDataModifier } from '@wix/a11y-adapters/studio';
import { isEditor3Host } from '../../utils/get-editor-host';
const DESKTOP_COMPONENT_TYPE = 'DESKTOP';
export const headingStructureOnApply = async (newTag, oldTag, oldHeadingHtmlString, oldHeadingCompId, uiElementId, adapter, editorHost) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(oldHeadingHtmlString, 'text/html');
  const oldHeadingElement = doc.querySelector(oldTag);
  if (!oldHeadingElement) {
    throw new Error(`Old heading tag <${oldTag}> not found in provided HTML`);
  }
  const newHeadingHtmlString = copyHeadingTagContent(newTag, oldHeadingElement);
  if (isEditor3Host(editorHost)) {
    if (adapter.isBuilderRichTextComponent != null && adapter.isBuilderRichTextComponent({
      id: oldHeadingCompId,
      type: DESKTOP_COMPONENT_TYPE
    })) {
      adapter.setHTMLTagForBuilderRichTextComponent == null || adapter.setHTMLTagForBuilderRichTextComponent(newTag);
    } else {
      throw new Error(`Heading with id ${oldHeadingCompId} is not a builder rich text component`);
    }
  } else {
    let headingStudioComponent;
    try {
      headingStudioComponent = adapter.getComponent({
        id: oldHeadingCompId,
        type: DESKTOP_COMPONENT_TYPE
      });
    } catch (err) {
      throw new Error(`Component with id ${oldHeadingCompId} not found`);
    }
    const {
      data: updatedData
    } = dsStudioDataModifier.updateTextHeadingLevel(headingStudioComponent, newTag);
    if (!updatedData) {
      throw new Error('Failed to update heading level - missing data');
    }
    adapter.setComponentData({
      id: oldHeadingCompId,
      type: DESKTOP_COMPONENT_TYPE
    }, {
      ...updatedData
    });
  }
  return {
    htmlString: newHeadingHtmlString,
    id: oldHeadingCompId,
    uiElementId
  };
};

// This logic is needed only for UI purposes
export const copyHeadingTagContent = (newHeadingTag, oldHeading) => {
  const newHeading = window.document.createElement(newHeadingTag);
  for (const attr of oldHeading.attributes) {
    newHeading.setAttribute(attr.name, attr.value);
  }
  newHeading.innerHTML = oldHeading.innerHTML;
  return newHeading.outerHTML;
};
//# sourceMappingURL=heading-structure-on-apply.js.map